import React, { Component } from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import MainLayout from '../CommonControlls/MainLayout';
import Topmenu from '../CommonControlls/Topmenubar';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import DropDown from '../CommonControlls/DropdownRendrer'
import AlertModal from '../CommonControlls/AlertModal';

const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({ type: "UpdateAlert", payload: Settings })
        },
        ShowLoader: (Isloading) => {
            dispatch({ type: "UpdateLoader", payload: Isloading })
        },
    }
}

class Administrator_Add extends Component {

    constructor(props) {
        super(props);
        this.state = {

            //Roles
            RolesLoader: false,
            Roleslist: [],
            RoleId: 0,

            Id: 0,

            alertModalData: {
                title: "",
                message: "",
                First_Callback: () => {
                },
                Second_Callback: () => {
                },
                type: 1,
            },

            Banklist: [],
            BankId: 0,
            BankLoader: false,

            FilteredRHC: [],
            FilteredBHU: [],

            ClustersList: [],
            FilteredClustersList: [],
            ClusterId: [],


            HCFLoader: false,
            BHUList: [],
            RHCList: [],
            BHUId: 0,
            RHCId: 0,

            XpertSiteLoader: false,
            XpertSitelist: [],
            FilteredXpertSites: [],
            XpertSiteId: 0,

            XpertSideId: 0,

            ProvinceLoader: false,
            Provincelist: [],
            ProvinceId: 0,

            FilteredDistrictlist: [],
            AddressDistrictId: 0,

            TehsilLoader: false,
            Tehsillist: [],
            FilteredTehsillist: [],
            TehsilId: 0,

            DistrictLoader: false,
            Districtlist: [],
            DistrictId: 0,

        };
    }

    HandleAutoSuggestValChange = (fieldId, value) => {
        this.setState({ [fieldId]: value }, () => {
            if (fieldId === "ProvinceId") {
                var TempArr = this.state.Districtlist
                var filteredArr = TempArr.filter(function (obj) {
                    return obj.provinceId == value;
                });
                this.setState({
                    FilteredDistrictlist: filteredArr,
                })
            }
            if (fieldId === "AddressDistrictId") {
                var TempArr = this.state.Tehsillist
                var filteredArr = TempArr.filter(function (obj) {
                    return obj.districtId == value;
                });
                const TempBHU = this.state.BHUList
                const filteredBHU = TempBHU.filter(item => +item.districtId === value)

                const TempRHC = this.state.RHCList
                const filteredRHC = TempRHC.filter(item => +item.districtId === value)

                const TempXpert = this.state.XpertSitelist
                const filteredXpert = TempXpert.filter(item => +item.districtId === value)
                this.setState({
                    FilteredTehsillist: filteredArr,
                    FilteredBHU: filteredBHU,
                    FilteredRHC: filteredRHC,
                    FilteredXpertSites: filteredXpert
                })
            }
            if (fieldId === "DistrictId") {
                var TempClustersList = this.state.ClustersList
                var filteredClustersList = TempClustersList.filter(function (obj) {
                    return (obj.districtId === value)
                });

                var selectedCluster = this.state.ClusterId
                var filteredClusterIdArr = Common.ConvertToCommaSplitArray(filteredClustersList, "id")
                var filteredSelectedCluster = selectedCluster.filter(function (obj) {
                    return filteredClusterIdArr.indexOf(obj.id) > -1
                });

                this.setState({
                    FilteredClustersList: filteredClustersList,
                    ClusterId: filteredSelectedCluster,
                })
            }
        })
    }

    render() {

        return (

            <div>
                <MainLayout />
                <AlertModal  {...this.state.alertModalData} />
                <div id="right-panel" class="right-panel">
                    <Topmenu PageTitle={"Add Administrator"} isShowAddBtn={false} />
                    <div class="content col-md-12 col-lg-12 d-flex justify-content-center">

                        {/* <div class="PageHeader_Container">
                            <h2>{this.state.Id==0?"Add User":"Edit User"}</h2>
                        </div> */}

                        <div class="card col-md-8 col-lg-8">
                            <div class="card-body row">

                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <form onSubmit={this.SubmitForm} novalidate>
                                        <div class="row">

                                            <div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <label for=""><span style={{ color: "red" }}>* </span>Name</label>
                                                <input autocomplete="off" type="text" class="form-control" id="UserName"
                                                    placeholder="Enter name" required />
                                            </div>

                                            <div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <label for=""><span style={{ color: "red" }}>*</span>Phone</label>
                                                <input autocomplete="off" pattern="[0][0-9]{10}" type="text"
                                                    class="form-control" id="UserPhone"
                                                    placeholder="Enter user phone - 03123456789" required />
                                            </div>
                                            <div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <label for="">Email</label>
                                                <input autocomplete="off" type="email" class="form-control"
                                                    id="UserEmail" placeholder="Enter user email" />
                                            </div>

                                            <div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <label for="">CNIC</label>
                                                <input autocomplete="off" type="text" class="form-control"
                                                    id="UserCnic" maxLength="15" placeholder="Enter user CNIC (e.g., 3730355985553)" />
                                            </div>

                                            <div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <label for=""><span style={{ color: "red" }}>*</span>Password</label>
                                                <input autocomplete="off" type="password" class="form-control"
                                                    id="UserPassword" placeholder="Password" required />
                                                <i id="viewpasswordlink"
                                                    onClick={((e) => this.updatepasswordviewfun(1))}
                                                    class="fa fa-eye viewpasswordicon" aria-hidden="true"></i>
                                                <i id="hidepasswordlink"
                                                    onClick={((e) => this.updatepasswordviewfun(2))}
                                                    class="fa fa-eye-slash viewpasswordicon" style={{ display: "none" }}
                                                    aria-hidden="true"></i>
                                            </div>

                                            <div class="formInput_Container col-md-16 col-lg-6 col-12">
                                                <label for=""><span style={{ color: "red" }}>* </span> Province</label>
                                                <DropDown
                                                    multi={false}
                                                    dropdownRenderer={false}
                                                    create={false}
                                                    onChange={this.HandleAutoSuggestValChange}
                                                    Type="ProvinceId"
                                                    options={this.state.Provincelist}
                                                    val={this.state.ProvinceId}
                                                    addPlaceholder=""
                                                    disabled={false}
                                                    loading={this.state.ProvinceLoader}
                                                    searchBy="name"
                                                    labelField="name"
                                                    valueField="id"
                                                    contentRenderer={false}
                                                    placeholder="Select"
                                                />
                                            </div>

                                            <div class="formInput_Container col-md-6 col-lg-6 col-12">
                                                <label for=""><span style={{ color: "red" }}>* </span>District</label>
                                                <DropDown
                                                    multi={false}
                                                    dropdownRenderer={false}
                                                    create={false}
                                                    onChange={this.HandleAutoSuggestValChange}
                                                    Type="AddressDistrictId"
                                                    options={this.state.FilteredDistrictlist}
                                                    val={this.state.AddressDistrictId}
                                                    addPlaceholder=""
                                                    disabled={false}
                                                    loading={this.state.DistrictLoader}
                                                    searchBy="name"
                                                    labelField="name"
                                                    valueField="id"
                                                    contentRenderer={false}
                                                    placeholder="Select"
                                                />
                                            </div>

                                            <div class="formInput_Container col-md-6 col-lg-6 col-12">
                                                <label for=""><span style={{ color: "red" }}>* </span> Tehsil</label>
                                                <DropDown
                                                    multi={false}
                                                    dropdownRenderer={false}
                                                    create={false}
                                                    onChange={this.HandleAutoSuggestValChange}
                                                    Type="TehsilId"
                                                    options={this.state.FilteredTehsillist}
                                                    val={this.state.TehsilId}
                                                    addPlaceholder=""
                                                    disabled={false}
                                                    loading={this.state.TehsilLoader}
                                                    searchBy="name"
                                                    labelField="name"
                                                    valueField="id"
                                                    contentRenderer={false}
                                                    placeholder="Select"
                                                />
                                            </div>

                                            <div class="formInput_Container col-md-6 col-lg-6 col-12">
                                                <label for=""><span style={{ color: "red" }}>* </span>Role</label>
                                                <DropDown
                                                    multi={false}
                                                    dropdownRenderer={false}
                                                    create={false}
                                                    onChange={this.HandleAutoSuggestValChange}
                                                    Type="RoleId"
                                                    options={this.state.Roleslist}
                                                    val={this.state.RoleId}
                                                    addPlaceholder=""
                                                    disabled={false}
                                                    loading={this.state.RolesLoader}
                                                    searchBy="roleName"
                                                    labelField="roleName"
                                                    valueField="id"
                                                    contentRenderer={false}
                                                    placeholder="Select"
                                                />
                                            </div>


                                            <div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <label>Gender</label>
                                                <select id="gender" className="form-control">
                                                    <option value="1">Male</option>
                                                    <option value="2">Female</option>
                                                </select>
                                            </div>


                                            <div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12"
                                                hidden={this.state.RoleId !== 6}>
                                                <label htmlFor=""><span style={{ color: "red" }}>* </span>BHU</label>
                                                <DropDown
                                                    multi={false}
                                                    dropdownRenderer={false}
                                                    create={false}
                                                    onChange={this.HandleAutoSuggestValChange}
                                                    Type="BHUId"
                                                    options={this.state.FilteredBHU}
                                                    val={this.state.BHUId}
                                                    addPlaceholder=""
                                                    // disabled={this.state.Id !== 0}
                                                    loading={this.state.HCFLoader}
                                                    searchBy="name"
                                                    labelField="name"
                                                    valueField="id"
                                                    contentRenderer={false}
                                                    placeholder="Select"
                                                />
                                            </div>

                                            <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                                hidden={this.state.RoleId !== 7}>
                                                <label htmlFor=""><span style={{ color: "red" }}>* </span>RHC</label>
                                                <DropDown
                                                    multi={false}
                                                    dropdownRenderer={false}
                                                    create={false}
                                                    onChange={this.HandleAutoSuggestValChange}
                                                    Type="RHCId"
                                                    options={this.state.FilteredRHC}
                                                    val={this.state.RHCId}
                                                    addPlaceholder=""
                                                    // disabled={this.state.Id !== 0}
                                                    loading={this.state.HCFLoader}
                                                    searchBy="name"
                                                    labelField="name"
                                                    valueField="id"
                                                    contentRenderer={false}
                                                    placeholder="Select"
                                                />
                                            </div>

                                            {this.state.RoleId === 3 && <div
                                                className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                            >
                                                <label htmlFor=""><span style={{ color: "red" }}>* </span> Xpert
                                                    Site</label>
                                                <DropDown
                                                    multi={false}
                                                    dropdownRenderer={false}
                                                    create={false}
                                                    onChange={this.HandleAutoSuggestValChange}
                                                    Type="XpertSiteId"
                                                    options={this.state.FilteredXpertSites}
                                                    val={this.state.XpertSiteId}
                                                    addPlaceholder=""
                                                    // disabled={this.state.Id !== 0}
                                                    loading={this.state.XpertSiteLoader}
                                                    searchBy="name"
                                                    labelField="name"
                                                    valueField="id"
                                                    contentRenderer={false}
                                                    placeholder="Select"
                                                />
                                            </div>}

                                            <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                                hidden={this.state.RoleId !== 5}>
                                                <label htmlFor=""><span style={{ color: "red" }}>* </span>Supervisor's
                                                    District</label>
                                                <DropDown
                                                    multi={false}
                                                    dropdownRenderer={false}
                                                    create={false}
                                                    onChange={this.HandleAutoSuggestValChange}
                                                    Type="DistrictId"
                                                    options={this.state.Districtlist}
                                                    val={this.state.DistrictId}
                                                    addPlaceholder=""
                                                    disabled={!(this.state.Id === 0 || this.state.saveddistictId === 0 || this.state.saveddistictId === null)}
                                                    loading={this.state.DistrictLoader}
                                                    searchBy="name"
                                                    labelField="name"
                                                    valueField="id"
                                                    contentRenderer={false}
                                                    placeholder="Select"
                                                />
                                            </div>

                                            <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                                hidden={this.state.RoleId !== 5}>
                                                <label htmlFor=""><span style={{ color: "red" }}>* </span>Supervisor's
                                                    Clusters</label>
                                                <DropDown
                                                    multi={true}
                                                    dropdownRenderer={true}
                                                    create={false}
                                                    onChange={this.HandleAutoSuggestValChange}
                                                    Type="ClusterId"
                                                    options={this.state.FilteredClustersList}
                                                    val={this.state.ClusterId}
                                                    addPlaceholder=""
                                                    // disabled={this.state.Id==0 || this.state.savedClusterId=="" || this.state.savedClusterId==null ?false: true}
                                                    loading={this.state.ClusterLoader}
                                                    searchBy="name"
                                                    labelField="name"
                                                    valueField="id"
                                                    contentRenderer={false}
                                                    placeholder="Select"
                                                />
                                            </div>

                                            <div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12"
                                                hidden={this.state.RoleId !== 4}>
                                                <label htmlFor=""><span style={{ color: "red" }}>* </span>Vehicle
                                                    Number</label>
                                                <input autoComplete="off" type="text" className="form-control"
                                                    id="VehicleNumber" placeholder="Enter user vehicle number"
                                                    required={this.state.RoleId === 4} />
                                            </div>

                                            <div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12"
                                                hidden={this.state.RoleId !== 4}>
                                                <label htmlFor=""><span style={{ color: "red" }}>* </span>Vehicle
                                                    Model</label>
                                                <input autoComplete="off" type="text" className="form-control"
                                                    id="VehicleModel" placeholder="Enter user vehicle model"
                                                    required={this.state.RoleId === 4} />
                                            </div>

                                            <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                                hidden={this.state.RoleId !== 8}>
                                                <label htmlFor=""><span style={{ color: "red" }}>* </span>Districts
                                                    Allowed To
                                                    SR Admin</label>
                                                <DropDown
                                                    multi={true}
                                                    dropdownRenderer={true}
                                                    create={false}
                                                    onChange={this.HandleAutoSuggestValChange}
                                                    Type="SRDistrictId"
                                                    options={this.state.CompleteDistrictlist}
                                                    val={this.state.SRDistrictId}
                                                    addPlaceholder=""
                                                    disabled={false}
                                                    loading={this.state.DistrictLoader}
                                                    searchBy="name"
                                                    labelField="name"
                                                    valueField="id"
                                                    contentRenderer={true}
                                                    placeholder="Select"
                                                />
                                            </div>

                                            <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                                hidden={this.state.RoleId !== 4}>
                                                <label htmlFor="">Bank</label>
                                                <DropDown
                                                    multi={false}
                                                    dropdownRenderer={false}
                                                    create={false}
                                                    onChange={this.HandleAutoSuggestValChange}
                                                    Type="BankId"
                                                    options={this.state.Banklist}
                                                    val={this.state.BankId}
                                                    addPlaceholder=""
                                                    disabled={false}
                                                    loading={this.state.BankLoader}
                                                    searchBy="name"
                                                    labelField="name"
                                                    valueField="id"
                                                    contentRenderer={false}
                                                    placeholder="Select"
                                                />
                                            </div>





                                            <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                                hidden={this.state.RoleId !== 4}>
                                                <label htmlFor="">Account Number</label>
                                                <input autoComplete="off" type="text" className="form-control"
                                                    id="AccountNumber" placeholder="Enter rider Account Number" />
                                            </div>

                                            <div
                                                class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <button type="submit" id="Form_SaveBtn" class="btn btn_style1"
                                                    hidden={this.state.Id === this.state.loggedinUser}>Save
                                                </button>
                                                {/* <button type="button" onClick={this.onDelete} id="Form_DeleteBtn" class="btn btn_style2" hidden={this.state.Id== this.state.loggedinUser ? true: this.state.Id==0?true:false}>Delete</button> */}
                                                <Link to="/Administrators">
                                                    <button type="button" id="Form_CancelBtn"
                                                        class="btn btn_style3">Cancel
                                                    </button>
                                                </Link>

                                                {/* Hide button for reset */}
                                                <Link style={{ display: "none" }} to="/User_Add">
                                                    <button id="Form_ResetBtn" type="button"
                                                        class="btn initial-btn Cancel-Form-btn Form_Btn">Reset
                                                    </button>
                                                </Link>
                                            </div>

                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

        )
    }

    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login")
        }

        Common.parseJwt(this.props.UserAuthentication.AuthToken, (user) => {
            this.setState({
                loggedinUser: user.id
            })
        })
    }

    componentDidMount() {
        var Id = Common.GetId()
        if (Id !== 0) {
            this.SelectUser(Id)
        }

        this.SelectProvinces()
        this.SelectDistricts()
        this.SelectTehsil()
        this.SelectRoles()
        this.SelectAllBanksList()
        this.SelectXpertSites()
        this.SelectHCF()

        // CNIC input validation and formatting
        $("#UserCnic").on("input", (e) => {
            let value = e.target.value.replace(/\D/g, ''); // Remove all non-digits

            // Format CNIC with dashes
            if (value.length > 0) {
                if (value.length <= 5) {
                    value = value;
                } else if (value.length <= 12) {
                    value = value.substring(0, 5) + '-' + value.substring(5);
                } else {
                    value = value.substring(0, 5) + '-' + value.substring(5, 12) + '-' + value.substring(12, 13);
                }
            }

            e.target.value = value;
        });
    }

    SelectAllBanksList = () => {
        this.setState({ BankLoader: true })
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_Bank, {}, (data) => {
            this.setState({
                BankLoader: false,
                Banklist: data.data
            })
        }, (error) => {
            this.setState({ BankLoader: false })
            this.props.ShowAlert({ Type: 0, Msg: error })
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
        })
    }
    SelectXpertSites = () => {
        this.setState({ XpertSiteLoader: true })
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_XpertSites, {}, (data) => {
            this.setState({
                XpertSiteLoader: false,
                XpertSitelist: data.data
            })
        }, (error) => {
            this.setState({ XpertSiteLoader: false })
            this.props.ShowAlert({ Type: 0, Msg: error })
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
        })
    }

    SelectHCF = () => {
        this.setState({ HCFLoader: true })
        Common.Ajax(this.props.UserAuthentication?.AuthToken, 'GET', false, Common.APILinks.SelectAll_HCF, {}, (data) => {
            var BHUList = []
            var RHCList = []
            for (var i = 0; i < data.data.length; i++) {
                if (data.data[i].typeId === 1) {
                    BHUList.push(data.data[i])
                } else {
                    RHCList.push(data.data[i])
                }
            }
            this.setState({
                HCFList: data.data,
                BHUList: BHUList,
                RHCList: RHCList,
                HCFLoader: false
            })
        }, (error) => {
            this.setState({ HCFLoader: false })
            this.props.ShowAlert({ Type: 0, Msg: error })
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
        })
    }
    ResetForm = () => {
        $("#UserName").val("")
        $("#UserPhone").val("")
        $("#UserEmail").val("")
        $("#UserPassword").val("")
    }
    SubmitForm = (e) => {
        e.preventDefault()

        // CNIC validation
        const cnic = $("#UserCnic").val();
        if (cnic) {
            // Validate CNIC format: #####-#######-#
            const cnicPattern = /^\d{5}-\d{7}-\d{1}$/;
            if (!cnicPattern.test(cnic)) {
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "CNIC should be in format: #####-#######-# (e.g., 37303-5598555-3)",
                });

                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
                return;
            }

            // Check if CNIC contains only digits and dashes in correct positions
            const cnicDigits = cnic.replace(/-/g, '');
            if (cnicDigits.length !== 13) {
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "CNIC should contain exactly 13 digits",
                });

                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
                return;
            }
        }

        const formData = {
            imageURLBase64: this.state.isImageUpdated ? this.state.imageURLBase64 : "",
            hcfId: 0,
            id: this.state.Id,
            xpertSiteId: this.state.XpertSiteId ? this.state.XpertSiteId : 0,
            vehicleNumber: $("#VehicleNumber").val() ? $("#VehicleNumber").val() : "0",
            accountNumber: $("#AccountNumber").val() ? $("#AccountNumber").val() : "0",
            bankId: this.state.bankId ? this.state.bankId : 0,
            dfsAssigendClusters: "0",
            vehicleModel: $("#VehicleModel").val() ? $("#VehicleModel").val() :
                "0",
            srDistrictIds: "0",
            role: this.state.RoleId,
            addressProvinceId: this.state.ProvinceId,
            addressTehsilId: this.state.TehsilId,
            addressDistrictId: this.state.AddressDistrictId,
            name: $("#UserName").val(),
            cnic: $("#UserCnic").val(),
            contact: $('#UserPhone').val(),
            email: $("#UserEmail").val(),
            password: $('#UserPassword').val(),
            gender: $('#gender').val(),
            isActive: true
        }
        this.props.ShowLoader({ Isloading: true })

        Common.Ajax(this.props.UserAuthentication.AuthToken, "Post", false, this.state.Id === 0 ?
            Common.APILinks.Add_Administrator : Common.APILinks.Update_User, JSON.stringify(formData), (resp) => {
                if (resp.status === true) {
                    this.props.ShowLoader({ Isloading: false })
                    $("#Form_ResetBtn").click()
                    this.ResetForm()
                    this.props.history.push('/Administrators')
                    this.props.ShowAlert({ Type: 1, Msg: this.state.Id === 0 ? "Saved successfully" : "Updated successfully" })
                    setTimeout(() => {
                        $("#Alertmsgbtn").click()
                    }, 50);
                } else {
                    this.props.ShowLoader({ Isloading: false })
                    this.props.ShowAlert({ Type: 0, Msg: resp.message })
                    setTimeout(() => {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({ Type: 0, Msg: "Something went wrong, please try again." })
                setTimeout(() => {
                    $("#Alertmsgbtn").click()
                }, 50);
            })

    }
    updatepasswordviewfun = (type) => {
        if (type === 1) {
            $("#hidepasswordlink").show()
            $("#viewpasswordlink").hide()
            $("#UserPassword").prop('type', 'text');
        } else {
            $("#hidepasswordlink").hide()
            $("#viewpasswordlink").show()
            $("#UserPassword").prop('type', 'password');
        }

    }
    SelectProvinces = () => {
        this.setState({ ProvinceLoader: true })
        Common.Ajax("", "Get", false, Common.APILinks.SelectAll_Province, { isPaginate: false },
            (Result) => {
                if (Result.status === true) {
                    this.setState({
                        Provincelist: Result.data,
                        ProvinceLoader: false
                    })
                } else {
                    this.setState({
                        ProvinceLoader: false
                    })
                    this.props.ShowAlert({ Type: 0, Msg: Result.message })
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.setState({
                    ProvinceLoader: false
                })
                this.props.ShowAlert({ Type: 0, Msg: "Something went wronge, please try again" })
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        )
    }
    SelectDistricts = () => {
        this.setState({ DistrictLoader: true })
        Common.Ajax("", "Get", false, Common.APILinks.SelectAll_District, { isPaginate: false },
            (Result) => {
                if (Result.status === true) {
                    this.setState({
                        Districtlist: Result.data,
                        DistrictLoader: false
                    })
                } else {
                    this.setState({
                        DistrictLoader: false
                    })
                    this.props.ShowAlert({ Type: 0, Msg: Result.message })
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.setState({
                    DistrictLoader: false
                })
                this.props.ShowAlert({ Type: 0, Msg: "Something went wrong, please try again" })
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        )

    }
    SelectRoles = () => {
        this.setState({ RolesLoader: true })

        var Parameters = {
            pageSize: this.state.sizePerPage,
            pageNumber: this.state.page,
        }

        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.SelectAll_Role, Parameters, (resp) => {
            this.setState({ loading: false })
            if (resp.status) {
                this.setState({
                    Roleslist: resp.data.reverse(),
                    RolesLoader: false
                })
            } else {
                this.props.ShowAlert({ Type: 0, Msg: resp.message })
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        },
            (error) => {

                $("#FormSearchBtn").prop('disabled', false);
                this.setState({ RolesLoader: false })
                this.props.ShowAlert({ Type: 0, Msg: "Something went wronge, please try again." })
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        )
    }
    SelectTehsil = () => {
        this.setState({ TehsilLoader: true })
        Common.Ajax("", "Get", false, Common.APILinks.SelectAll_Tehsil, { isPaginate: false },
            (Result) => {
                if (Result.status === true) {
                    this.setState({
                        Tehsillist: Result.data,
                        TehsilLoader: false
                    })
                } else {
                    this.setState({
                        TehsilLoader: false
                    })
                    this.props.ShowAlert({ Type: 0, Msg: Result.message })
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.setState({
                    TehsilLoader: false
                })
                this.props.ShowAlert({ Type: 0, Msg: "Something went wronge, please try again" })
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        )

    }
    SelectUser = (id) => {
        this.props.ShowLoader({ Isloading: true })
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.Select_User, { Id: id }, (resp) => {
            this.props.ShowLoader({ Isloading: false })
            if (resp.status) {
                this.LoadDataInEditMode(resp.data)
            } else {
                this.props.ShowAlert({ Type: 0, Msg: resp.message })
                setTimeout(() => {
                    $("#Alertmsgbtn").click()
                }, 50);
                if (resp.message === "No record found.")
                    $("#Form_CancelBtn").click()
            }
        },
            (error) => {
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({ Type: 0, Msg: "Something went wrong, please try again." })
                setTimeout(() => {
                    $("#Alertmsgbtn").click()
                }, 50);
            })
    }
    LoadDataInEditMode = (data) => {
        this.setState({
            Id: data.id,
            isImageUpdated: false,
            RoleId: data.role,
            isActive: data.isActive,
            XpertSiteId: data.xpertSiteId,
            DistrictId: data.districtId,
            imageURL: data.imageURL,
            ProvinceId: data.addressProvinceId,
            AddressDistrictId: data.addressDistrictId,
            TehsilId: data.addressTehsilId,
            imageURLBase64: data.imageURLBase64 === "" ? "" : data.imageURLBase64,
            BankId: data.bankId,
        })
        $("#UserName").val(data.name)
        $("#UserPhone").val(data.contact)
        $("#UserEmail").val(data.email)
        $("#UserPassword").val(data.password)
        $("#UserAddress").val(data.address)
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(Administrator_Add);
